












































import Vue from 'vue'
import { namespace } from 'vuex-class'
import PostGroup from '@/model/post/postGroup'
import { Component } from 'vue-property-decorator'
import { collectPostGroup, unCollectPostGroup } from '@/api/post/collect'

const ModuleGlobal = namespace('app-sandwich/global')
const ModuleUser = namespace('app-sandwich/user')

@Component
export default class AllGroup extends Vue {
  @ModuleGlobal.State(state => state.postGroupList)
  private postGroupList!: PostGroup[]
  @ModuleGlobal.Action('fetchPostGroup') private fetchPostGroup!: Function
  @ModuleUser.State(state => state.collectPostGroups)
  private collectPostGroups!: PostGroup[]
  @ModuleUser.Action('fetchCollectPostGroup')
  private fetchCollectPostGroup!: Function

  private mounted() {
    this.fetchCollectPostGroup()
    this.fetchPostGroup()
  }
  private toDetail(id: string) {
    window.open(`/post/m/group/${id}`)
  }

  private async collect(postGroup: PostGroup) {
    let result
    if (postGroup.isCollected) {
      result = await unCollectPostGroup(postGroup.id)
    } else {
      result = await collectPostGroup([postGroup.id])
    }
    if (result) {
      this.fetchCollectPostGroup()
    }
  }

  //computed
  get handledPostGroupList() {
    if (this.postGroupList && this.collectPostGroups) {
      const collectIdList = this.collectPostGroups.map(
        postGroup => postGroup.id
      )
      this.postGroupList.map(postGroup => {
        postGroup.isCollected = collectIdList.indexOf(postGroup.id) !== -1
      })
    }
    return this.postGroupList || []
  }

  private getLogo(icon: string) {
    return `background-image:url(${icon})`
  }

  // private isCollected(postGroupId: string) {
  //   let collectionIds: string[] = []
  //   for (const item of this.collectPostGroups) {
  //     collectionIds.push(item.id)
  //   }
  //   return collectionIds.includes(postGroupId)
  // }
}
